// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mfo1RpF1plpy9wzgRn-cgQ\\=\\={position:relative}", "",{"version":3,"sources":["webpack://./src/shared/layouts/Dashboard/components/Header/components/HeaderNotificationIndicator/HeaderNotificationIndicator.module.scss"],"names":[],"mappings":"AAAA,4BACI,iBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HeaderNotificationIndicator": "mfo1RpF1plpy9wzgRn-cgQ=="
};
export default ___CSS_LOADER_EXPORT___;
